import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
 
Vue.use(VueCompositionApi)

